import React from 'react';
// import { Sun, Moon, LogOut, UserPlus, FileText, Upload, ArrowLeft, ArrowRight } from 'lucide-react';
import { Sun, Moon, LogOut, FileText, Upload, ArrowLeft, ArrowRight } from 'lucide-react';
import { useAppContext } from '../../context/AppContext';

const ChatHeader = () => {
  const {
    theme,
    toggleTheme,
    user,
    logout,
    // openAddUserModal,
    openDocumentModal,
    openUploadModal,
    isSidebarOpen,
    setIsSidebarOpen
  } = useAppContext();

  if (!user) {
    return null;
  }

const BouncingLuminAI = ({ theme = 'dark' }) => {
  const text = 'LuminAI';
  
  return (
    <h2>
      {text.split('').map((letter, index) => (
        <span
          key={index}
          className="inline-block animate-bounce"
          style={{
            animationDelay: `${index * 2}s`,
            animationDuration: '2s'
          }}
        >
          {letter}
        </span>
      ))}
    </h2>
  );
};

  return (
    <div className={`flex items-center justify-between p-4  chat-header`}>
      <div className="flex items-center gap-3">
        <button
          type="button"
          onClick={() => setIsSidebarOpen((prev) => !prev)}
          className="history-toggle flex items-center justify-center w-8 h-8"
          title={isSidebarOpen ? 'Close history panel' : 'Open history panel'}
          aria-label={isSidebarOpen ? 'Close history panel' : 'Open history panel'}
        >
          {isSidebarOpen ? <ArrowLeft size={16} /> : <ArrowRight size={16} />}
        </button>
        <div className={`text-2xl font-semibold ${theme === 'dark' ? 'text-white' : 'text-black'} flex`}>
          <BouncingLuminAI />
        </div>
        <span className={`ml-2 px-2 py-0.5 ${theme === 'dark' ? 'bg-gray-800 text-gray-400' : 'bg-gray-100 text-gray-600'} border border-gray-700/50 rounded-lg text-xs `}>latest</span>
      </div>
    
      <div className="flex items-center gap-4 mr-4">
        
        <div className="group relative px-1 py-1  border border-gray-700/50 rounded-lg">
            <div className="relative flex items-center gap-2">
              <div className="w-2 h-2 bg-green-400 rounded-full animate-pulse" />
              <span className={` text-sm font-semibold  ${theme === 'dark' ? 'text-white' : 'text-black'}`}> {user.username} </span>
            </div>
        </div>
        
        <button
          onClick={toggleTheme}
          title="Toggle Theme"
          className={`rounded-xl flex items-center justify-center
            transition-all duration-300
            ${theme === 'dark'
              ? 'bg-gray-900/70 text-gray-300 hover:bg-gray-800/90 hover:text-yellow-400'
              : 'bg-white/70 text-gray-700 hover:bg-gray-100/90 hover:text-blue-600'
            }`}
        >
          {theme === 'dark' ? (
            <Sun
              size={22}
              className="transition-transform duration-300 hover:scale-110"
            />
          ) : (
            <Moon
              size={22}
              className="transition-transform duration-300 hover:scale-110"
            />
          )}
        </button>
        
        {['admin'].includes((user.user_type || '').toLowerCase()) && (
          <button
            type="button"
            onClick={openDocumentModal}
            title="Preview Documents"
            className={`flex items-center justify-center  transition-all duration-300
              ${theme === 'dark'
                ? 'bg-gray-900/70 text-gray-100 hover:bg-gray-800/90 hover:text-blue-400'
                : 'bg-white/70 text-gray-800 hover:bg-gray-100/90 hover:text-blue-600'
              }`}
          >
            <FileText size={22} className="transition-transform duration-300 hover:scale-110" />
          </button>
        )}

        {['admin'].includes((user.user_type || '').toLowerCase()) && (
          <button
            type="button"
            onClick={openUploadModal}
            title="Upload & Index Documents"
            className={`flex items-center justify-center  transition-all duration-300
              ${theme === 'dark'
                ? 'bg-gray-900/70 text-gray-100 hover:bg-gray-800/90 hover:text-blue-400'
                : 'bg-white/70 text-gray-800 hover:bg-gray-100/90 hover:text-blue-600'
              }`}
          >
            <Upload size={22} className="transition-transform duration-300 hover:scale-110" />
          </button>
        )}
        
        

          {/* {user.user_type === 'admin' && (
            <button 
              type="button" 
              onClick={openAddUserModal}  
              title="Add User"
              className={`flex items-center justify-center  transition-all duration-300
                ${theme === 'dark'
                  ? 'bg-gray-900/70 text-gray-100 hover:bg-gray-800/90 hover:text-blue-400'
                  : 'bg-white/70 text-gray-800 hover:bg-gray-100/90 hover:text-blue-600'
                }`}
            >
              <UserPlus size={22} className="transition-transform duration-300 hover:scale-110" />
            </button>
          )} */}


        <button
          onClick={logout}
          title="Logout"
          className={`flex items-center justify-center rounded-xl 
            transition-all duration-300
            ${theme === 'dark'
              ? 'bg-gray-900/70 text-gray-300 hover:bg-gray-800/90 hover:text-red-400'
              : 'bg-white/70 text-gray-700 hover:bg-gray-100/90 hover:text-red-600'
            }`}
        >
          <LogOut size={22} className="transition-transform duration-300 hover:scale-110" />
        </button>
        
      </div>
    </div>
  );
};

export default ChatHeader;
